// opervex-frontend/src/Opervex/Financial/Accounts.js

class Accounts {
  #_api;
  constructor(api) {
    this.#_api = api;
  }
  async findAll() {
    return this.#_api.get("/Financial/Accounts");
  }
  async findId(id) {
    return this.#_api.get(`/Financial/Accounts/${id}`);
  }
  async create(data) {
    return this.#_api.post("/Financial/Accounts", data);
  }
  async update(id, data) {
    return this.#_api.put(`/Financial/Accounts/${id}`, data);
  }
  async schema() {
    return [
      { key: "id", label: "Código", type: "number", visible: true },
      { key: "code", label: "Conta", type: "string", visible: true },
      { key: "description", label: "Descrição", type: "string", visible: true },
      { key: "accountType", label: "Tipo", type: "string", visible: true },
    ];
  }
}
export default Accounts;
